module.exports = __webpack_public_path__ + "static/img/icon_alarm_black_active1.3028523.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_alarm_black_active1.svg
// module id = +KxY
// module chunks = 10